import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InstallPwaModal from './components/InstallPwaModal';
import UpdateAvailableModal from './components/UpdateAvailableModal';
import Login from './components/Login';
import Dashboard from './components/HR Manager/screens/Dashboard';
import AddCostCenter from './components/HR Manager/screens/AddCostCenter';
import CostCenters from './components/HR Manager/screens/CostCenters';
import CreateDepartment from './components/HR Manager/screens/CreateDepartment';
import Departments from './components/HR Manager/screens/Departments';
import CreateEmployee from './components/HR Manager/screens/CreateEmployee';
import Employees from './components/HR Manager/screens/Employees';
import UpdateEmployee from './components/HR Manager/screens/UpdateEmployee';
import EmployeeGoals from './components/HR Manager/screens/EmployeeGoals';
import EmployeeDashboard from './components/Employee/screens/EmployeeDashboard';
import AddKRA from './components/Employee/screens/AddKRA';
import KRAs from './components/Employee/screens/KRAs';
import CreateGoal from './components/Employee/screens/CreateGoal';
import MyGoals from './components/Employee/screens/MyGoals';
import CreateBulkGoals from './components/Employee/screens/CreateBulkGoals';
import HODDashboard from './components/HOD/screens/HODDashboard';
import DepartmentEmployees from './components/HOD/screens/DepartmentEmployees';
import HODEmployeeGoals from './components/HOD/screens/HODEmployeeGoals';
import Analytics from './components/HR Manager/screens/Analytics';
import HRChangePassword from './components/HR Manager/screens/HRChangePassword';
import ChangePassword from './components/Employee/screens/ChangePassword';
import HODChangePassword from './components/HOD/screens/HODChangePassword';
import HRGoals from './components/HR Manager/screens/HRGoals';
import HRCreateGoal from './components/HR Manager/screens/HRCreateGoal';
import HRAddKRA from './components/HR Manager/screens/HRAddKRA';
import HRKRAs from './components/HR Manager/screens/HRKRAs';
import HRProfile from './components/HR Manager/screens/HRProfile';
import HODCreateGoal from './components/HOD/screens/HODCreateGoal';
import HODGoals from './components/HOD/screens/HODGoals';
import HODAddKRA from './components/HOD/screens/HODAddKRA';
import HODKRAs from './components/HOD/screens/HODKRAs';
import HODProfile from './components/HOD/screens/HODProfile'
import HODCreateEmployee from './components/HOD/screens/HODCreateEmployee';
import PendingGoals from './components/HOD/screens/PendingGoals'
import EmployeeGoalsReview from './components/HOD/screens/EmployeeGoalsReview';
import GoalReviews from './components/Employee/screens/GoalReviews';
import AllEmployeeGoalsReview from './components/HR Manager/screens/AllEmployeesGoalsReview';
import MyReviews from './components/HOD/screens/MyReviews';
import MyGoalReviews from './components/HR Manager/screens/MyGoalReviews';
import HREmployees from './components/HR Manager/screens/HREmployees';
import HREmployeesGoals from './components/HR Manager/screens/HREmployeesGoals';
import HREmployeeGoalsReview from './components/HR Manager/screens/HREmployeeGoalsReview';
import COODashboard from './components/coo/screens/COODashboard';
import COOEmployees from './components/coo/screens/COOEmployees';
import COOEmployeeGoals from './components/coo/screens/COOEmployeeGoals';
import COOChangePassword from './components/coo/screens/COOChangePassword';
import COOAddKRA from './components/coo/screens/COOAddKRA';
import COOKRAs from './components/coo/screens/COOKRAs';
import COOCreateGoal from './components/coo/screens/COOCreateGoal';
import COOGoals from './components/coo/screens/COOGoals';
import COOEmployeeGoalsReview from './components/coo/screens/COOEmployeeGoalsReview';
import COOGoalsReviews from './components/coo/screens/COOGoalsReviews';
import COOPendingGoals from './components/coo/screens/COOPendingGoals';
import COOCreateImprovementPlan from './components/coo/screens/COOCreateImprovementPlan'
import COOImprovementPlan from './components/coo/screens/COOImprovementPlan'
import PasswordReset from './components/PasswordReset';
import CreateImprovementPlan from './components/Employee/screens/CreateImprovementPlan'
import ImprovementPlans from './components/Employee/screens/ImprovementPlans'
import EmployeeImprovementPlan from './components/HOD/screens/EmployeeImprovementPlan'
import HODCreateImprovementPlan from './components/HOD/screens/HODCreateImprovementPlan'
import HODImprovementPlan from './components/HOD/screens/HODImprovementPlan'
import HRCreateImprovementPlan from './components/HR Manager/screens/HRCreateImprovementPlan'
import HRImprovementPlans from './components/HR Manager/screens/HRImprovementPlans'
import DepartmentEmployeesImprovementPlans from './components/HR Manager/screens/DepartmentEmployeesImprovementPlans'
import HODsImprovementPlans from './components/coo/screens/HODsImprovementPlans'
import COOEditIP from './components/coo/screens/COOEditIP'
import HREditIP from './components/HR Manager/screens/HREditIP'
import HODEditIP from './components/HOD/screens/HODEditIP'
import EmployeeEditIP from './components/Employee/screens/EmployeeEditIP'
import HREmployeesPendingGoals from './components/HR Manager/screens/HREmployeesPendingGoals'
import HODUpdateEmployee from './components/HOD/screens/HODUpdateEmployee';
import COOCreateEmployee from './components/coo/screens/COOCreateEmployee';
import COOUpdateEmployee from './components/coo/screens/COOEditEmployee';
import HRImportKPIs from './components/HR Manager/screens/HRImportKPIs';
import HODImportKPIs from './components/HOD/screens/HODImportKPIs';
import EmployeeImportKPIs from './components/Employee/screens/EmployeeImportKPIs';
import COOImportKPIs from './components/coo/screens/COOImportKPIs';



function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/reset-password/:token" element={<PasswordReset />} />
          {/* HR Manager */}
          <Route path="/login" element={<Login />} />
          <Route path="/hr/dashboard" element={<Dashboard />} />
          <Route path="/hr/analytics" element={<Analytics />} />
          <Route path="/hr/cost-centers/add" element={<AddCostCenter />} />
          <Route path="/hr/cost-centers" element={<CostCenters />} />
          <Route path="/hr/department/add" element={<CreateDepartment />} />
          <Route path="/hr/departments" element={<Departments />} />
          <Route path="/hr/create-goal" element={<HRCreateGoal />} />
          <Route path="/hr/goals" element={<HRGoals />} />
          <Route path="/hr/profile" element={<HRProfile />} />
          <Route path="/hr/add-key-result-area" element={<HRAddKRA />} />
          <Route path="/hr/key-result-areas" element={<HRKRAs />} />
          <Route path="/hr/add-employee" element={<CreateEmployee />} />
          <Route path="/hr/employees" element={<Employees />} />
          <Route path="/hr/employee/:id/update" element={<UpdateEmployee />} />
          <Route path="/hr/employee/:id/goals" element={<EmployeeGoals />} />
          <Route path="/hr/change-password" element={<HRChangePassword />} />
          <Route path="/hr/employee/:id/reviews" element={<AllEmployeeGoalsReview />} /> 
          <Route path="/hr/my-goal-reviews" element={<MyGoalReviews /> } />
          <Route path="/hr/department-employees" element={<HREmployees />} />
          <Route path="/hr/department-employee/:id/goals" element={<HREmployeesGoals />} />
          <Route path="/hr/employee-goals/:id/reviews" element={<HREmployeeGoalsReview />} /> 
          <Route path="/hr/create-improvement-plan" element={<HRCreateImprovementPlan />} /> 
          <Route path="/hr/improvement-plans" element={<HRImprovementPlans />} />
          <Route path="/hr/department-employees-improvement-plans" element={<DepartmentEmployeesImprovementPlans />} />
          <Route path="/hr/edit-improvement-plan/:id" element={<HREditIP />} />
          <Route path="/hr/department-employees-pending-goals" element={<HREmployeesPendingGoals />} />
          <Route path="/hr/import-kpis" element={<HRImportKPIs />} />
          {/* COO */}
          <Route path="/coo/dashboard" element={<COODashboard />} />
          <Route path='/coo/employees' element={<COOEmployees />} />
          <Route path='/coo/employee/:id/goals' element={<COOEmployeeGoals />} />
          <Route path='/coo/employee-goals/:id/reviews' element={<COOEmployeeGoalsReview />} />
          <Route path='/coo/change-password' element={<COOChangePassword />} />
          <Route path='/coo/create-key-result-area' element={<COOAddKRA />} />
          <Route path='/coo/key-result-areas' element={<COOKRAs />} />
          <Route path='/coo/create-goal' element={<COOCreateGoal />} />
          <Route path='/coo/goals' element={<COOGoals />} />
          <Route path='/coo/my-goals-reviews' element={<COOGoalsReviews />} />
          <Route path='/coo/pending-goals' element={<COOPendingGoals />} />
          <Route path='/coo/create-improvement-plan' element={<COOCreateImprovementPlan />} />
          <Route path='/coo/improvement-plans' element={<COOImprovementPlan />} />
          <Route path='/coo/hods-improvement-plans' element={<HODsImprovementPlans />} />
          <Route path='/coo/edit-improvement-plan/:id' element={<COOEditIP />} />
          <Route path='/coo/add-employee' element={<COOCreateEmployee />} />
          <Route path='/coo/update-employee/:id' element={<COOUpdateEmployee />} />
          <Route path='/coo/import-kpis' element={<COOImportKPIs />} />

          {/* Employee */}
          <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
          <Route path="/employee/key-result-area/add" element={<AddKRA />} />
          <Route path="/employee/key-result-area/view" element={<KRAs />} />
          <Route path="/employee/goal/add" element={<CreateGoal />} />
          <Route path="/employee/goals" element={<MyGoals />} />
          <Route path="/employee/goals/add" element={<CreateBulkGoals />} />
          <Route path="/employee/change-password" element={<ChangePassword />} />
          <Route path="/employee/goal-reviews" element={<GoalReviews />} />
          <Route path="/employee/create-improvement-plan" element={<CreateImprovementPlan />} />
          <Route path="/employee/improvement-plans" element={<ImprovementPlans />} />
          <Route path="/employee/edit-improvement-plan/:id" element={<EmployeeEditIP />} />
          <Route path="/employee/import-kpis" element={<EmployeeImportKPIs />} />

          {/* HOD */}
          <Route path="/hod/dashboard" element={<HODDashboard />} />
          <Route path="/hod/employees" element={<DepartmentEmployees />} />
          <Route path="/hod/employee/:id/goals" element={<HODEmployeeGoals />} />
          <Route path="/hod/change-password" element={<HODChangePassword />} />
          <Route path="/hod/create-key-result-area" element={<HODAddKRA />} />
          <Route path="/hod/key-result-areas" element={<HODKRAs />} />
          <Route path="/hod/profile" element={<HODProfile />} />
          <Route path="/hod/goals" element={<HODGoals />} />
          <Route path="/hod/add-employee" element={<HODCreateEmployee />} />
          <Route path="/hod/create-goal" element={<HODCreateGoal />} />
          <Route path='/hod/pending-goals' element={<PendingGoals />} />
          <Route path='/hod/employee-goals/:id/reviews' element={<EmployeeGoalsReview />} />
          <Route path='/hod/my-goals-reviews' element={<MyReviews />} />
          <Route path='/hod/create-improvement-plan' element={<HODCreateImprovementPlan />} />
          <Route path='/hod/improvement-plans' element={<HODImprovementPlan />} />
          <Route path='/hod/employees-improvement-plans' element={<EmployeeImprovementPlan />} />
          <Route path='/hod/edit-improvement-plan/:id' element={<HODEditIP />} />
          <Route path='/hod/update-employee/:id' element={<HODUpdateEmployee/>} />
          <Route path='/hod/import-kpis' element={<HODImportKPIs />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>

      <InstallPwaModal />
      <UpdateAvailableModal />
      
      <ToastContainer
        position="top-right"
        autoClose={6000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
